import { call, take }   from 'redux-saga/effects';
import axios            from 'axios';

const endpoint = `https://www.yisumatica.org.il/users/publicaccess/logout/`;

function* signOut(): Generator<any,any,any> {
    while(true) {
      try {

        yield take('LOG_OUT_SAGA');

        if (process.env.NODE_ENV === 'development') {
          return
        }

        yield call( axios.post, endpoint)
        window.location.assign('https://www.yisumatica.org.il/flash-upload/pisa-math-login/')

        console.log('signOut')

      }
      catch (err) { console.log('err  :  '+err); }
      finally {}
    }
  }

export default signOut;
